//
// # Built-In Elements Library
//
// The builtin symbol data now lives in the repo-root /schematic-builtins/*.json
// files (the single source of truth), embedded here via the committed,
// generated `./generated` module (regenerate with `yarn gen-builtins`).
//

import { allBuiltins } from "./generated";
export * from "./generated";

// FIXME more to come

// The union type of all the builtins
export type Builtin = (typeof allBuiltins)[number];

// Lookup table keyed on the builtin's id, for `find`.
const byId = new Map<string, Builtin>(allBuiltins.map((b) => [b.id, b]));

export const Builtin = { find, list };

// List all available builtins
export function list(): Array<Builtin> {
  return allBuiltins;
}

// Same idea as `get`, but taking any string, and returning `undefined` if its not a valid `Id`.
export function find(id: string): Builtin | undefined {
  return byId.get(id);
}

// // Get a builtin from its `Id`
// export function get(id: BuiltinId): Builtin {
//   switch (id) {
//     case "nmos":
//       return Nmos;
//     case "pmos":
//       return Pmos;
//     case "res":
//       return Res;
//     default:
//       exhaust(id);
//   }
// }
